import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * 获取相对于东八区的时间戳
 * 例如
 *  西五区 2020-02-02 02:02
 *  转换到时间戳
 *  在东八区转换回时间是 2020-02-02 15:02
 *  想要获取一样的时间节点，要进行相对于东八区偏移量计算
 * @param {Date实例} date
 * @returns {string} 时间戳
 */
export default function getTimestampTZ8(date) {
    if (date === void 0) {
        date = new Date();
    }
    var now = dayjs(date);
    var tz8 = now.tz('Asia/Shanghai');
    var offset = now.utcOffset();
    var timeOffset = Math.abs(offset / 60);
    if (offset > 0) {
        if (offset < 8) {
            return tz8.subtract(8 - timeOffset, 'h').valueOf();
        }
        if (offset > 8) {
            return tz8.add(timeOffset - 8, 'h').valueOf();
        }
        return tz8.valueOf();
    }
    return tz8.subtract(8 + timeOffset, 'h').valueOf();
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/date/getTimestampTZ8.js
// module id = null
// module chunks = 